import React from 'react';
import { Button, Row, Col, Form } from '../../../ui-kit';
import { IconUndo } from '../../../ui-kit/icons';
import SaveButton from '../../../general/SaveButton';

const Toolbar = ({
  membershipTree,
  selectedGroupId,
  setSelectedGroupId,
  undoUnsavedChanges,
  processUnsavedChanges,
  hasUnsavedChanges,
  processing,
  editMode
}) => (
  <Row className="mb-2">
    {editMode && (
      <>
        <Col sm={3}>
          <small>{I18n.t('dashboards.widget_archetypes.personal_calendar.currently_editing')}</small>
        </Col>
        <Col sm={5}>
          <Form.Select value={selectedGroupId || ''} onChange={e => setSelectedGroupId(Number(e.target.value))}>
            {membershipTree.map(membership => (
              <option key={membership.group_id} value={membership.group_id || ''}>
                {membership.group.name}{' '}
              </option>
            ))}
          </Form.Select>
        </Col>
        <Col sm={4} className="d-flex justify-content-end">
          <Button disabled={processing} className="me-1" variant="secondary" onClick={undoUnsavedChanges}>
            <IconUndo />
          </Button>
          <SaveButton onClick={processUnsavedChanges} hasUnsavedChanges={hasUnsavedChanges} isSaving={processing} />
        </Col>
      </>
    )}
  </Row>
);

export default Toolbar;
